const awaitApproval = {
  v: "5.5.7",
  meta: { g: "LottieFiles AE 0.1.20", a: "", k: "", d: "", tc: "none" },
  fr: 29.9700012207031,
  ip: 0,
  op: 60.0000024438501,
  w: 1475,
  h: 1263,
  nm: "14",
  ddd: 0,
  assets: [
    {
      id: "image_0",
      w: 117,
      h: 189,
      u: "",
      p:
        "data:image/png;base64,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",
      e: 1,
    },
    {
      id: "image_1",
      w: 60,
      h: 110,
      u: "",
      p:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAABuCAYAAAB7unCOAAAEUklEQVR4Xu2dXXLTMBCAV54cIJyAcgLKCQhJOsNjeachnID2BNATUE6AcXkH3pip44YTUE4AnAD6HiRGTuLKsmxJbifxruK3xJKtTyvt6me1ZmC4hqPJGTDYN93rxH8CrrJZctymLMwIPJ78AoD7bR64qTxZmhjLbnt/JdNgMO1HPf7HlnHb9zmLHs0v4ivfclSAx+PpgAO/9H3QptMzwZ/NZh8/+763AjwcHx0DsLe+D9p4egHv2vTjCvCTg0nMBLzYOIDvCwX8yGaJt2I1SHgyB4DHvu/fRnq+iO7N5/Ffn3ebgIXPA7aalomX2cV57FOGEvDg6XQvWvCfPg/YZloG8GWWJoc+ZSgBY9HQKiDvRQ/mX2M5bnC6SsDD8eQNALx2ytmdRKdZmshyO10lYDQauox2zRfRnqvy0iWMRkNr4nSWsg6MR0O3lHIBjGUM3dBRnaRcAGPU0Bq8U18ugNGMoZt0scP4WgFGaZIq+Da7rAJj1dAlaMHgw+VFMq1rCDfAo8kVMHjoZL07nqhJyqqEsZqkSvU3STkHJmCSqn25ZuqYAxMwSaZOZrTLOfDw4GgKgr3veNf0Ld51liZ9PdMSGOcsyV4BhgWCHBjpLMkODPAtS5OBmnAtYRI22FQDuolaAhOywVUbVV7OXUuYjA02SPl3liZ76/9DAAZ1W4YRtcFlQSuzqFCAi10KNho9PxQs+uSi4zGnWWtrRnbQURliLXcpwgFe9eNwgFejLglMdpSlt2rpJhEUsFRcQQFHED3ZAWO2tfayi5OgJAwApxK4805odsk5pzhlpOfC1XrIJRyMHZbObEEB78ySc9dHmlCufATVpEMbS+c7ESFJOF+UDwdYWQAIww6v9pmCkfB6bTqUJZ5i6zQIYNXNOAhgUPaJgwBWt0zpA2uHQegDgzjJ0vOzYruU+lZLxQOAhFNp3ezNcLaJ+HZpuTnLeiENbPK5pAtcc1SPLrCmnQstTdXHo86FmKaEG06e0gQGqD3hwkj6Sjccl6fomFbyvKtzHybjeuh0yGM4npABtgVDINekbcfkaQE7BEKgBmwNdUHKQdzWf/PZ0uqQB4nFeFv/pQbcaH91j3j0ErbZX3LAUDMdrBtpoZew9N9I01hyNF5klJaLwrpRWsuQcK9stdPh+04KS9XSGCO0qPVfOXJXJxwqhy2dQlrQkbBHmCkSEnbV0GQk7KqhyQD7xLjEHwPAYQ6samz8wIZT4E3jBfzADvF3qEnY2QYXSgv1/pKHDSYB7GODC+DBwXQ/Evx7hycHtUVrBbxa10K5GO9jgwsJ74ARte3QJOw8Dy4t4iFu0jtgW29EHRPPdS26MrRcNWmMS7Vew0rdLO2Abf2hA/fbS1gtvAyd3ltAEZKJw799ALaMLyegr33WRKbb1lc/7gb4NpKTMy81Pwd+81uvrOXv1sFDXfaDdZZSfOnbgN5VXr3ChFj0BYuM33PgvSj2iQ8vy/gfDqSQ+zf4ZXQAAAAASUVORK5CYII=",
      e: 1,
    },
    {
      id: "image_2",
      w: 51,
      h: 179,
      u: "",
      p:
        "data:image/png;base64,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",
      e: 1,
    },
    {
      id: "image_3",
      w: 68,
      h: 118,
      u: "",
      p:
        "data:image/png;base64,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",
      e: 1,
    },
    {
      id: "image_4",
      w: 19,
      h: 19,
      u: "",
      p:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAABMklEQVQ4T6WUMU7DQBBF/xALpSMoFm3CCYAb5AZwA2jjFJgaR1oJQxunwC7hBnAUOAGmJigXWGfQLjisHVssG7eeeZ7//4wJls9yJnpyV4YEyv3JzWNTG9mwPrJoRAwFGBDw2g/i43/DlpkYFigSMJ+azR3yDvfHIq8DWyf7TK9DBgkAe5tNfNUPbpM/YUrSDiNh4KjNgjap68mUwUVXCjAubXxskqphi/vpBYjV2BuSWsGEuT+OQ/M9LdJIpXRuM02t5t0P4mEVlk2f62nZgle8OjmY3L2U9fST2swWUKmrSSW9SyzfnGBARep3AGmkFnDgAjSlljDXEABDqrkaDy6TwZCqYVv6hlLq+gK28a2U+gvLosT2lBrs0Kmak50BeHL0TUutHLrsysafns0HPHj5F2IOg2PGtsXkAAAAAElFTkSuQmCC",
      e: 1,
    },
    {
      id: "image_5",
      w: 53,
      h: 160,
      u: "",
      p:
        "data:image/png;base64,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",
      e: 1,
    },
    {
      id: "image_6",
      w: 307,
      h: 552,
      u: "",
      p:
        "data:image/png;base64,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",
      e: 1,
    },
    {
      id: "image_7",
      w: 585,
      h: 402,
      u: "",
      p:
        "data:image/png;base64,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",
      e: 1,
    },
    {
      id: "comp_0",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Lap1 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [247.582, -85.862, 0], ix: 2 },
            a: { a: 0, k: [466.582, 415.138, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [9.075, 16.142],
                        [17.968, -15.685],
                        [16.336, -16.142],
                        [7.856, 14.207],
                        [-17.677, 9.769],
                        [-17.968, 11.44],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.886274576187, 0.09411765635, 0.21960785985, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [281.763, 570.724], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-10.236, -3.062],
                        [-0.395, -0.884],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.532, 0.044],
                      ],
                      o: [
                        [0, 0],
                        [2.102, 0.627],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [2.089, 0.715],
                      ],
                      v: [
                        [-1.214, -4.339],
                        [8.618, 3.868],
                        [10.431, 6.001],
                        [-1.35, 6.001],
                        [-5.962, 0.81],
                        [-7.396, 2.045],
                        [-10.72, -1.227],
                        [-6.636, -6.002],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.105999995213, 0.141000007181, 0.255000005984, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [261.777, 664.925], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0.007, -0.048],
                        [-6.549, -1.838],
                        [-16.395, -0.899],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [4.323, 0.921],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-0.007, 0.048],
                        [-0.764, 6.764],
                        [0, 0],
                        [-10.763, 13.833],
                        [0, 0],
                        [0, 0],
                        [1.711, -4.078],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-29.818, -39.46],
                        [-30.248, -35.917],
                        [-30.267, -35.773],
                        [-20.032, -20.902],
                        [9.35, -15.7],
                        [-4.389, 36.941],
                        [2.544, 39.461],
                        [29.32, -24.378],
                        [24.29, -34.008],
                        [-1.285, -39.46],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.258999992819, 0.26699999641, 0.368999974868, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [260.318, 618.134], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 3",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [1.173, 1.383],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-1.743, 0.497],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [3.456, -1.541],
                        [1.542, 2.875],
                        [-3.245, 1.419],
                        [-3.456, 1.17],
                        [-1.91, -3.372],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [258.597, 658.688], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 4",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "Lap2 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [0] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.667], y: [1.154] },
                  o: { x: [0.333], y: [0] },
                  t: 17,
                  s: [14],
                },
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [-1.193] },
                  t: 43,
                  s: [1],
                },
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [0] },
                  t: 74,
                  s: [-1],
                },
                { t: 90.0000036657751, s: [0] },
              ],
              ix: 10,
            },
            p: { a: 0, k: [44.795, 94.099, 0], ix: 2 },
            a: { a: 0, k: [263.795, 595.099, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-10.238, -3.062],
                        [-0.395, -0.884],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.531, 0.042],
                      ],
                      o: [
                        [0, 0],
                        [2.1, 0.628],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [2.089, 0.713],
                      ],
                      v: [
                        [-1.638, -4.296],
                        [8.621, 3.868],
                        [10.431, 6.001],
                        [-1.348, 6.001],
                        [-5.96, 0.811],
                        [-7.396, 2.044],
                        [-10.721, -1.226],
                        [-7.611, -6.001],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.105999995213, 0.141000007181, 0.255000005984, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [292.779, 667.228], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.868, 14.535],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -8.233],
                        [0, 0],
                      ],
                      v: [
                        [4.876, -18.844],
                        [13.777, 36.102],
                        [5.863, 36.102],
                        [-13.777, -27.87],
                        [4.191, -27.87],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.258999992819, 0.26699999641, 0.368999974868, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [277.572, 622.969], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [1.555, 0.931],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-1.49, 1.032],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [2.431, -2.948],
                        [3.233, 1.851],
                        [-1.768, 2.018],
                        [-2.048, 1.851],
                        [-3.233, -2.948],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [287.762, 661.591], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 3",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Lap3 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 11,
                  s: [2],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 24,
                  s: [-12],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 37,
                  s: [4],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 54,
                  s: [-6],
                },
                { t: 67.0000027289659, s: [0] },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 0,
                  s: [23.321, 29.152, 0],
                  to: [-0.333, 0, 0],
                  ti: [-1.113, 0, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 26,
                  s: [21.321, 29.152, 0],
                  to: [1.113, 0, 0],
                  ti: [0.053, 0, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 49,
                  s: [30, 29.152, 0],
                  to: [-0.053, 0, 0],
                  ti: [1.113, 0, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 75,
                  s: [21, 29.152, 0],
                  to: [-1.113, 0, 0],
                  ti: [-0.387, 0, 0],
                },
                { t: 89.0000036250443, s: [23.321, 29.152, 0] },
              ],
              ix: 2,
            },
            a: { a: 0, k: [242.321, 530.152, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-0.052, 0.305],
                        [-6.04, -1.264],
                        [0.065, -0.19],
                        [11.863, 6.31],
                      ],
                      o: [
                        [11.541, 6.233],
                        [-0.061, 0.343],
                        [-5.81, -1.189],
                        [0.015, -0.327],
                      ],
                      v: [
                        [-17.186, -6.389],
                        [17.301, 5.572],
                        [17.119, 6.389],
                        [-17.301, -5.413],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.917647063732, 0.913725495338, 0.913725495338, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [248.461, 573.661], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [3.06, -4.887],
                        [-0.954, -1.102],
                        [-6.311, -2.419],
                        [0.006, -0.461],
                        [2.957, 3.409],
                        [-0.979, 1.56],
                        [-0.054, 0.047],
                        [0, 0],
                      ],
                      o: [
                        [-0.778, 1.24],
                        [2.711, 3.125],
                        [-0.009, 0.389],
                        [-6.627, -2.492],
                        [-1.202, -1.383],
                        [3.12, -4.985],
                        [0, 0],
                        [-0.053, 0.047],
                      ],
                      v: [
                        [-7.429, -1.637],
                        [-7.135, 2.28],
                        [9.12, 11.162],
                        [9.12, 12.037],
                        [-7.773, 2.836],
                        [-8.147, -2.088],
                        [0.366, -12.038],
                        [0.938, -11.413],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.917647063732, 0.913725495338, 0.913725495338, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [247.409, 555.858], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [3.126, -4.995],
                        [-1.073, -1.234],
                        [0, 0],
                        [0, 0],
                        [10.643, 10.686],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-0.871, 1.387],
                        [5.941, 6.852],
                        [0, 0],
                        [0, 0],
                        [-10.921, -10.963],
                        [0, 0],
                      ],
                      v: [
                        [7.481, -10.211],
                        [-0.958, -0.347],
                        [-0.624, 4.07],
                        [26.49, 17.503],
                        [25.122, 25.232],
                        [-15.569, 8.632],
                        [1.742, -25.232],
                      ],
                      c: false,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [240.579, 554.343], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 3",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0.48, 0.277],
                        [0, 0],
                        [1.302, -0.272],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.995, 4.884],
                        [0, 0],
                      ],
                      o: [
                        [0.127, -0.541],
                        [0, 0],
                        [-1.152, -0.668],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.011, -0.246],
                        [0, 0],
                        [0, 0],
                        [0.124, 5.198],
                        [0, 0],
                      ],
                      v: [
                        [7.838, -0.71],
                        [7.245, -2.089],
                        [2.595, -4.788],
                        [-1.215, -5.404],
                        [-6.26, -5.204],
                        [-6.919, -4.405],
                        [-7.965, 0.057],
                        [-6.36, -0.343],
                        [-3.159, -0.255],
                        [5.88, 0.478],
                        [7.525, 5.276],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [271.495, 577.787], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 4",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "Lap4 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 34,
                  s: [-2],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 54,
                  s: [1],
                },
                { t: 89.0000036250443, s: [0] },
              ],
              ix: 10,
            },
            p: { a: 0, k: [11.5, 77.674, 0], ix: 2 },
            a: { a: 0, k: [230.5, 578.674, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [7.24, 3.748],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-10.912, 10.924],
                        [0, 0],
                        [0.965, -23.862],
                      ],
                      v: [
                        [6.171, -21.366],
                        [-0.255, -26.369],
                        [-14.748, 26.369],
                        [13.783, 26.369],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [245.249, 552.305], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ty: "gr",
                  it: [
                    {
                      ind: 0,
                      ty: "sh",
                      ix: 1,
                      ks: {
                        a: 0,
                        k: {
                          i: [
                            [-0.676, 0.386],
                            [-0.617, -0.777],
                            [0.676, -0.383],
                            [0.617, 0.778],
                          ],
                          o: [
                            [0.676, -0.385],
                            [0.616, 0.779],
                            [-0.676, 0.385],
                            [-0.616, -0.779],
                          ],
                          v: [
                            [-1.116, -1.409],
                            [1.225, -0.697],
                            [1.117, 1.409],
                            [-1.224, 0.698],
                          ],
                          c: true,
                        },
                        ix: 2,
                      },
                      nm: "Path 1",
                      mn: "ADBE Vector Shape - Group",
                      hd: false,
                    },
                    {
                      ty: "fl",
                      c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                      o: { a: 0, k: 100, ix: 5 },
                      r: 1,
                      bm: 0,
                      nm: "Fill 1",
                      mn: "ADBE Vector Graphic - Fill",
                      hd: false,
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [248.492, 516.36], ix: 2 },
                      a: { a: 0, k: [0, 0], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "Group 2",
                  np: 4,
                  cix: 2,
                  bm: 0,
                  ix: 1,
                  mn: "ADBE Vector Group",
                  hd: false,
                },
                {
                  ty: "gr",
                  it: [
                    {
                      ind: 0,
                      ty: "sh",
                      ix: 1,
                      ks: {
                        a: 0,
                        k: {
                          i: [
                            [0, 0],
                            [-1.234, -0.479],
                            [-1.073, -0.226],
                            [-0.815, 3.902],
                            [0, 0],
                            [0, 0],
                            [1.832, 0.8],
                            [0.347, -1.004],
                            [-0.663, -2.413],
                            [-0.845, -1.175],
                          ],
                          o: [
                            [0.58, -1.188],
                            [0.899, 0.346],
                            [2.563, 0.537],
                            [0.816, -3.901],
                            [0, 0],
                            [-1.995, 0.136],
                            [-1.617, -0.706],
                            [-0.757, 2.202],
                            [0.382, 1.397],
                            [0, 0],
                          ],
                          v: [
                            [-4.351, 1.232],
                            [-1.145, -0.039],
                            [1.914, 0.898],
                            [10.065, -2.513],
                            [5.815, -6.08],
                            [-0.916, -5.613],
                            [-6.722, -6.678],
                            [-10.124, -4.878],
                            [-9.427, 3.499],
                            [-7.569, 7.384],
                          ],
                          c: true,
                        },
                        ix: 2,
                      },
                      nm: "Path 1",
                      mn: "ADBE Vector Shape - Group",
                      hd: false,
                    },
                    {
                      ty: "fl",
                      c: { a: 0, k: [0.105999995213, 0.141000007181, 0.255000005984, 1], ix: 4 },
                      o: { a: 0, k: 100, ix: 5 },
                      r: 1,
                      bm: 0,
                      nm: "Fill 1",
                      mn: "ADBE Vector Graphic - Fill",
                      hd: false,
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [255.508, 512.045], ix: 2 },
                      a: { a: 0, k: [0, 0], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "Group 3",
                  np: 4,
                  cix: 2,
                  bm: 0,
                  ix: 2,
                  mn: "ADBE Vector Group",
                  hd: false,
                },
                {
                  ty: "gr",
                  it: [
                    {
                      ind: 0,
                      ty: "sh",
                      ix: 1,
                      ks: {
                        a: 0,
                        k: {
                          i: [
                            [-2.158, -0.389],
                            [-0.559, 0.29],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [-1.448, -1.604],
                          ],
                          o: [
                            [0.993, 0.18],
                            [3.709, -3.541],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [-0.505, 1.976],
                            [1.613, 1.413],
                          ],
                          v: [
                            [0.782, 9.042],
                            [3.277, 8.976],
                            [6.08, -6.397],
                            [1.937, -9.266],
                            [-4.589, -6.872],
                            [-6.481, 0.536],
                            [-4.98, 6.23],
                          ],
                          c: true,
                        },
                        ix: 2,
                      },
                      nm: "Path 1",
                      mn: "ADBE Vector Shape - Group",
                      hd: false,
                    },
                    {
                      ty: "fl",
                      c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                      o: { a: 0, k: 100, ix: 5 },
                      r: 1,
                      bm: 0,
                      nm: "Fill 1",
                      mn: "ADBE Vector Graphic - Fill",
                      hd: false,
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [254.595, 517.656], ix: 2 },
                      a: { a: 0, k: [0, 0], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "Group 4",
                  np: 4,
                  cix: 2,
                  bm: 0,
                  ix: 3,
                  mn: "ADBE Vector Group",
                  hd: false,
                },
                {
                  ty: "gr",
                  it: [
                    {
                      ind: 0,
                      ty: "sh",
                      ix: 1,
                      ks: {
                        a: 0,
                        k: {
                          i: [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                          ],
                          o: [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                          ],
                          v: [
                            [4.674, -0.825],
                            [1.719, 6.826],
                            [-4.674, 2.197],
                            [-0.358, -6.826],
                          ],
                          c: true,
                        },
                        ix: 2,
                      },
                      nm: "Path 1",
                      mn: "ADBE Vector Shape - Group",
                      hd: false,
                    },
                    {
                      ty: "fl",
                      c: { a: 0, k: [0.925, 0.588000009574, 0.486000001197, 1], ix: 4 },
                      o: { a: 0, k: 100, ix: 5 },
                      r: 1,
                      bm: 0,
                      nm: "Fill 1",
                      mn: "ADBE Vector Graphic - Fill",
                      hd: false,
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [248.297, 526.255], ix: 2 },
                      a: { a: 0, k: [0, 0], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "Group 5",
                  np: 4,
                  cix: 2,
                  bm: 0,
                  ix: 4,
                  mn: "ADBE Vector Group",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [466.583, 415.138], ix: 2 },
                  a: { a: 0, k: [466.583, 415.138], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 7",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-4.257, -14.069],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [4.26, 14.067],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-7.147, -10.798],
                        [11.404, 24.867],
                        [0.116, 20.242],
                        [-7.861, 1.79],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.917984068394, 0.91275292635, 0.913601696491, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [258.917, 558.432], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 6",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0,
        },
      ],
    },
    {
      id: "comp_1",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Guy1 Outlines",
          parent: 2,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [466.582, 415.138, 0], ix: 2 },
            a: { a: 0, k: [466.582, 415.138, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-0.855, 0.071],
                        [-0.161, -1.086],
                        [0.858, -0.071],
                        [0.159, 1.084],
                      ],
                      o: [
                        [0.858, -0.071],
                        [0.159, 1.084],
                        [-0.858, 0.071],
                        [-0.158, -1.084],
                      ],
                      v: [
                        [-0.288, -1.964],
                        [1.552, -0.127],
                        [0.285, 1.963],
                        [-1.553, 0.129],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [320.557, 282.861], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-3.903, 0.695],
                        [0, 0],
                        [5.134, 0.76],
                        [2.221, -1.185],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 2.337],
                        [-0.544, -0.265],
                        [0, -0.658],
                        [0, 0],
                        [-1.941, 0.597],
                        [0, 0],
                        [1.734, -1.942],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [3.903, -0.694],
                        [0, 0],
                        [-3.464, -0.512],
                        [-3.017, 1.61],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.651, -1.065],
                        [0.589, 0.288],
                        [0, 0],
                        [0, 0],
                        [1.943, -0.598],
                        [0, 0],
                        [-1.72, 1.929],
                        [0, 0],
                      ],
                      v: [
                        [-1.438, -7.714],
                        [6.173, -7.714],
                        [7.578, -12.713],
                        [-0.443, -12.153],
                        [-7.059, -12.153],
                        [-9.348, -5.082],
                        [-7.683, 6.472],
                        [-7.059, 6.472],
                        [-6.906, -2.736],
                        [-5.001, -3.536],
                        [-4.076, -1.949],
                        [-4.076, 10.046],
                        [5.497, 12.741],
                        [6.142, 3.257],
                        [2.168, 4.228],
                        [-1.636, 4.151],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.105999995213, 0.141000007181, 0.255000005984, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [326.24, 284.734], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-2.327, 0.071],
                        [-0.517, 0.464],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-1.851, -1.479],
                      ],
                      o: [
                        [1.066, -0.032],
                        [3.078, -4.913],
                        [0, 0],
                        [0, 0],
                        [-0.096, 2.369],
                        [1.981, 1.22],
                      ],
                      v: [
                        [1.914, 9.377],
                        [4.489, 8.707],
                        [4.061, -9.449],
                        [-7.116, -7.442],
                        [-7.471, 1.431],
                        [-4.679, 7.553],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [326.659, 284.231], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 3",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [-3.468, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [3.469, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-4.427, -7.099],
                        [-4.427, 4.461],
                        [0.958, 7.099],
                        [4.427, 4.596],
                        [4.427, -2.811],
                        [-0.707, -4.15],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.925, 0.588000009574, 0.486000001197, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [323.703, 294.225], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 4",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 151.000006150356,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "Guy2 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 10,
                  s: [8],
                },
                { t: 25.0000010182709, s: [0] },
              ],
              ix: 10,
            },
            p: { a: 0, k: [32.615, 87.103, 0], ix: 2 },
            a: { a: 0, k: [314.615, 356.103, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, -5.782],
                        [-1.087, -4.456],
                        [0.483, -0.125],
                        [0, 5.143],
                        [-0.484, 0.37],
                        [0, 0],
                      ],
                      o: [
                        [0, 5.232],
                        [-0.319, 0.086],
                        [-1.337, -5.504],
                        [0, -6.233],
                        [0, 0],
                        [-0.115, 0.086],
                      ],
                      v: [
                        [-5.289, -6.85],
                        [0.425, 21.967],
                        [-0.508, 22.203],
                        [-6.211, -6.85],
                        [5.651, -22.203],
                        [6.211, -21.469],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [312.66, 334.017], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, -10.476],
                        [0, 0],
                        [0, 0],
                        [0, 6.077],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 10.474],
                        [0, 0],
                        [0, 0],
                        [0, -6.077],
                        [0, 0],
                      ],
                      v: [
                        [3.191, -28.442],
                        [-12.526, -0.492],
                        [0.232, 28.442],
                        [6.532, 26.598],
                        [0.845, -2.326],
                        [12.526, -17.312],
                      ],
                      c: false,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [306.065, 329.493], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-0.461, 22.007],
                        [-0.461, -22.007],
                        [0.461, -21.978],
                        [0.461, 22.007],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [334.095, 332.005], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 3",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, -3.691],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-9.951, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [9.95, 0],
                      ],
                      v: [
                        [9.154, -27.918],
                        [13.9, -21.005],
                        [13.9, 28.004],
                        [-13.899, 28.004],
                        [-13.899, -17.815],
                        [-3.38, -28.004],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [320.195, 325.988], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 4",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [-3.235, 0.85],
                        [0.338, 0.37],
                        [1.598, 1.117],
                      ],
                      o: [
                        [0, 0],
                        [1.327, 2.676],
                        [0.486, -0.127],
                        [-1.776, -1.951],
                        [0, 0],
                      ],
                      v: [
                        [-6.42, -4.547],
                        [-3.667, 2.265],
                        [5.766, 4.16],
                        [6.083, 3.057],
                        [-1.901, -5.01],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [312.74, 361.231], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 5",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 5,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 151.000006150356,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Guy3 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [44.214, 194.455, 0], ix: 2 },
            a: { a: 0, k: [326.214, 463.455, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [5.896, -17.219],
                        [0, 0],
                        [0, 0],
                        [2.916, 26.603],
                      ],
                      o: [
                        [0, 0],
                        [-5.892, 17.219],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [16.312, -50.644],
                        [7.852, -2.316],
                        [-8.684, 50.644],
                        [-16.311, 50.644],
                        [-6.486, -50.644],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.258999992819, 0.26699999641, 0.368999974868, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [310.453, 404.636], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.396, 19.507],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [2.395, -19.509],
                      ],
                      v: [
                        [10.069, -40.878],
                        [8.522, 60.387],
                        [1.15, 60.387],
                        [-7.673, -40.878],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.258999992819, 0.26699999641, 0.368999974868, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [324.487, 394.893], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [1.307, 0.781],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-1.252, 0.869],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [2.382, -2.477],
                        [2.055, 1.554],
                        [-2.146, 1.696],
                        [-2.382, 1.554],
                        [-2.382, -2.477],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [297.798, 456.372], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 3",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-6.291, -1.604],
                        [0, -2.288],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.001, 0.721],
                      ],
                      o: [
                        [0, 0],
                        [1.383, 0.353],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-2.031, -3.167],
                        [5.593, 0.286],
                        [8.47, 3.167],
                        [2.262, 3.167],
                        [-4.087, 2.067],
                        [-4.087, 3.167],
                        [-7.515, 3.167],
                        [-6.468, -3.167],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.105999995213, 0.141000007181, 0.255000005984, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [301.885, 461.093], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 4",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [1.306, 0.783],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-1.25, 0.867],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [2.381, -2.478],
                        [2.055, 1.553],
                        [-2.143, 1.695],
                        [-2.381, 1.553],
                        [-2.381, -2.478],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [329.643, 455.569], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 5",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 5,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-6.29, -1.602],
                        [0, -2.287],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.001, 0.719],
                      ],
                      o: [
                        [0, 0],
                        [1.386, 0.354],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-2.032, -3.166],
                        [5.592, 0.285],
                        [8.47, 3.166],
                        [2.261, 3.166],
                        [-4.088, 2.067],
                        [-4.088, 3.166],
                        [-7.516, 3.166],
                        [-6.469, -3.166],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.105999995213, 0.141000007181, 0.255000005984, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [333.73, 460.289], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 6",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 6,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 151.000006150356,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "Guy4 Outlines",
          parent: 2,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 0,
                  s: [334.095, 304.982, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 16,
                  s: [334.095, 304.982, 0],
                  to: [0.333, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 31,
                  s: [336.095, 304.982, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 46,
                  s: [334.095, 304.982, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 58,
                  s: [336.095, 304.982, 0],
                  to: [0, 0, 0],
                  ti: [0.333, 0, 0],
                },
                { t: 70.0000028511585, s: [334.095, 304.982, 0] },
              ],
              ix: 2,
            },
            a: { a: 0, k: [334.095, 304.982, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, -1.358],
                        [0, 0],
                        [-1.425, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-1.425, 0],
                        [0, 0],
                        [0, 1.358],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [1.668, -3.449],
                        [0.922, -3.449],
                        [-1.668, -0.98],
                        [-1.668, 0.982],
                        [0.922, 3.449],
                        [1.668, 3.449],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.980000035903, 0.795999983245, 0.340999977261, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [334.712, 288.998], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [2.513, 0],
                        [0.313, 1.224],
                        [-0.537, 0.276],
                        [0, 0],
                      ],
                      o: [
                        [-0.223, 0.082],
                        [-1.83, 0],
                        [-0.111, -0.431],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [3.344, 2.027],
                        [-0.172, 2.599],
                        [-3.137, -0.873],
                        [-2.807, -2.193],
                        [0.133, -2.599],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [343.413, 299.295], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, -0.869],
                        [0.165, 0],
                        [0, 0.869],
                        [-0.163, 0],
                      ],
                      o: [
                        [0, 0.869],
                        [-0.163, 0],
                        [0, -0.869],
                        [0.165, 0],
                      ],
                      v: [
                        [0.297, 0],
                        [0, 1.575],
                        [-0.297, 0],
                        [0, -1.575],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.980000035903, 0.795999983245, 0.340999977261, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [355.711, 286.895], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 3",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 4.502],
                        [-1.177, 1.093],
                        [0, 0.002],
                        [0, 0],
                        [0, 0],
                        [-5.338, -5.21],
                        [-0.002, 0.002],
                      ],
                      o: [
                        [0, -4.498],
                        [-0.002, -0.002],
                        [-9.095, 6.57],
                        [0, 0],
                        [0, 0],
                        [0.002, 0],
                        [-1.177, -1.089],
                      ],
                      v: [
                        [7.836, 0.001],
                        [9.88, -9.362],
                        [9.876, -9.368],
                        [-9.883, -1.873],
                        [-9.883, 4.969],
                        [9.876, 9.368],
                        [9.883, 9.364],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.933000033509, 0.620000023935, 0.20800000359, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [345.828, 287.491], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 4",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-0.664, -3.291],
                        [1.504, -1.875],
                        [1.504, 1.26],
                        [-0.733, 3.291],
                        [-1.505, -0.787],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 0.995999983245, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [354.206, 287.21], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 5",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 5,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, -5.354],
                        [1.517, 0],
                        [0, 5.352],
                        [-1.515, 0],
                      ],
                      o: [
                        [0, 5.352],
                        [-1.515, 0],
                        [0, -5.354],
                        [1.517, 0],
                      ],
                      v: [
                        [2.746, 0.001],
                        [0, 9.692],
                        [-2.746, 0.001],
                        [0, -9.692],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.105999995213, 0.141000007181, 0.255000005984, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [356.409, 287.491], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 6",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 6,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-0.201, -0.969],
                        [-0.38, 0.077],
                        [0.198, 0.969],
                        [0.381, -0.079],
                      ],
                      o: [
                        [0.198, 0.969],
                        [0.38, -0.08],
                        [-0.198, -0.969],
                        [-0.38, 0.077],
                      ],
                      v: [
                        [-0.687, 0.143],
                        [0.36, 1.756],
                        [0.69, -0.141],
                        [-0.359, -1.754],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.980000035903, 0.795999983245, 0.340999977261, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [342.819, 296.628], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 7",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 7,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-0.207, 0.088],
                        [0.275, -0.006],
                        [-0.276, -0.088],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.862999949736, 0.246999987434, 0.368999974868, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [342.972, 298.365], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 8",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 8,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-0.201, -0.06],
                        [0.2, -0.154],
                        [0.171, 0.047],
                        [-0.097, 0.154],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.925, 0.579999976065, 0.310000011968, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [342.259, 295.028], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 9",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 9,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-0.198, -0.969],
                        [-0.382, 0.078],
                        [0.197, 0.969],
                        [0.379, -0.079],
                      ],
                      o: [
                        [0.198, 0.967],
                        [0.38, -0.079],
                        [-0.2, -0.969],
                        [-0.38, 0.077],
                      ],
                      v: [
                        [-0.689, 0.143],
                        [0.361, 1.755],
                        [0.69, -0.141],
                        [-0.359, -1.754],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.925, 0.579999976065, 0.310000011968, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [342.495, 296.695], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 10",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 10,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-3.329, -5.164],
                        [-0.165, 0.305],
                        [0.198, 0.297],
                        [-1.191, 3.841],
                        [0.808, 0.169],
                      ],
                      o: [
                        [0.478, -0.24],
                        [0.148, -0.28],
                        [-0.85, -1.262],
                        [-0.789, -0.637],
                        [-0.133, 4.222],
                      ],
                      v: [
                        [1.674, 6.103],
                        [2.411, 5.395],
                        [2.319, 4.482],
                        [0.046, -4.964],
                        [-2.426, -6.103],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.948999980852, 0.681999954523, 0.325, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [343.211, 297.415], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 11",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 11,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-4.176, -5.435],
                        [-0.478, -0.065],
                        [-0.526, 0.148],
                        [-0.177, 0.33],
                        [0.198, 0.297],
                        [-1.192, 3.842],
                      ],
                      o: [
                        [0, 0],
                        [0.259, 0.336],
                        [0.97, 0.131],
                        [0.77, -0.219],
                        [0.148, -0.28],
                        [-0.85, -1.262],
                        [-2.229, -1.801],
                      ],
                      v: [
                        [-3.197, -6.194],
                        [-0.319, 6.013],
                        [0.856, 6.667],
                        [3.031, 6.306],
                        [4.347, 5.362],
                        [4.256, 4.449],
                        [1.983, -4.997],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.925, 0.579999976065, 0.310000011968, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [341.273, 297.448], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 12",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 12,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0.065, -0.04],
                        [0, 0],
                        [-1.508, -0.822],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.509, 0.822],
                      ],
                      v: [
                        [-0.956, -0.37],
                        [5.336, 3.276],
                        [1.323, 3.276],
                        [-5.336, -2.302],
                        [-3.344, -2.454],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [343.242, 303.063], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 13",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 13,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [3.113, 1.057],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-0.595, -3.238],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [5.149, 4.892],
                        [4.882, 3.431],
                        [-1.917, -4.892],
                        [-5.148, -4.892],
                        [-4.148, 2.014],
                        [0.41, 4.892],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [345.103, 301.446], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 14",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 14,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-2.307, 0],
                        [0, 0],
                        [0, 0],
                        [7.607, -5.423],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [1.842, 0],
                        [0, 0],
                        [0, 0],
                        [-7.609, 5.423],
                        [0, 0],
                      ],
                      v: [
                        [-11.908, -22.206],
                        [-0.517, -1.003],
                        [-1.21, -18.315],
                        [6.399, -18.315],
                        [8.358, 16.783],
                        [-15.965, 1.438],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [345.314, 324.654], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 15",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 15,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 151.000006150356,
          st: 0,
          bm: 0,
        },
      ],
    },
    {
      id: "comp_2",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Girl 2/14 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [86.5, 125.5, 0], ix: 2 },
            a: { a: 0, k: [86.5, 125.5, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [3.451, -19.748],
                        [0, 0],
                        [39.498, 1.152],
                        [3.451, -6.137],
                        [-4.673, 19.558],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-3.451, 19.75],
                        [0, 0],
                        [-3.47, 4.972],
                        [69.024, 46.014],
                        [4.673, -19.557],
                        [0, 0],
                      ],
                      v: [
                        [-15.785, -59.053],
                        [-36.236, -31.827],
                        [0.574, 18.793],
                        [-46.592, 4.219],
                        [-52.343, 13.039],
                        [47.67, 34.896],
                        [12.337, -46.783],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.258999992819, 0.26699999641, 0.368999974868, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [70.315, 191.025], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [-0.402, -18.325],
                        [3.125, -4.073],
                        [0, 0],
                        [0, 0],
                        [-8.181, 10.677],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0.114, 5.129],
                        [-11.442, 14.912],
                        [0, 0],
                        [0, 0],
                        [8.181, -10.676],
                      ],
                      v: [
                        [12.525, -45.339],
                        [23.009, -31.947],
                        [28.26, -2.362],
                        [22.626, 10.37],
                        [-0.253, 45.985],
                        [-28.374, 33.716],
                        [-3.321, -35.309],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.885999971278, 0.141000007181, 0.224000010771, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [82.904, 98.256], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-14.586, -1.917],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [14.589, 1.917],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-35.629, -8.788],
                        [-9.917, 26.076],
                        [35.629, -22.816],
                        [28.067, -26.461],
                        [-5.19, -0.001],
                        [-18.501, -27.992],
                      ],
                      c: false,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.885999971278, 0.141000007181, 0.224000010771, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [117.985, 106.816], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 3",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [1.092, -1.205],
                        [0.244, -3.948],
                        [-3.988, 2.625],
                        [-2.305, -0.316],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-1.624, -0.082],
                        [-1.976, 2.188],
                        [-6.446, -8.04],
                        [1.942, -1.282],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [8.735, -2.13],
                        [1.024, -2.529],
                        [-3.522, -1.198],
                        [-5.121, 10.309],
                        [-1.095, -8.51],
                        [5.49, -9.992],
                        [11.567, -9.164],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [16.824, 205.629], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 4",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [3.619, 0.744],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.443, -0.278],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-3.777, 0],
                        [0, 0],
                        [1.509, 1.743],
                        [-1.284, 5.455],
                      ],
                      o: [
                        [0, 0],
                        [-3.622, -0.739],
                        [0, 0],
                        [0, 0],
                        [0.478, 0.2],
                        [0, 0],
                        [0, 0],
                        [-0.883, 3.114],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.517, -2.911],
                        [2.688, -11.407],
                      ],
                      v: [
                        [10.484, -11.594],
                        [6.376, -17.079],
                        [-2.998, -18.993],
                        [-3.943, -16.651],
                        [-0.006, -14.969],
                        [0.081, -13.834],
                        [-5.107, -11.54],
                        [-9.601, 4.336],
                        [-7.331, 12.835],
                        [0.521, 18.993],
                        [7.238, 18.993],
                        [6.473, 15.713],
                        [0.089, 2.957],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.113999998803, 0.118000000598, 0.187999994615, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [10.733, 207.143], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 5",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 5,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-1.306, 0.907],
                        [-1.255, -1.589],
                        [1.306, -0.907],
                        [1.257, 1.591],
                      ],
                      o: [
                        [1.306, -0.906],
                        [1.254, 1.588],
                        [-1.309, 0.904],
                        [-1.255, -1.588],
                      ],
                      v: [
                        [-2.271, -2.876],
                        [2.367, -1.64],
                        [2.274, 2.878],
                        [-2.366, 1.64],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [102.762, 30.864], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 6",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 6,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0.945, 2.378],
                        [2.481, -1.043],
                        [1.05, -2.245],
                        [0, 0],
                        [0, 0],
                        [-1.339, -1.879],
                        [0, 0],
                        [0, 0],
                        [-0.312, 3.052],
                      ],
                      o: [
                        [-1, -2.509],
                        [-2.286, 0.956],
                        [0, 0],
                        [0, 0],
                        [1.637, 1.597],
                        [0.575, -0.63],
                        [0, 0],
                        [2.473, -1.814],
                        [0.31, -3.025],
                      ],
                      v: [
                        [5.88, -9.187],
                        [2.046, -11.242],
                        [-3.099, -6.203],
                        [-9.255, 6.99],
                        [-9.361, 7.055],
                        [-4.891, 12.286],
                        [-3.998, 11.303],
                        [3.037, 6.094],
                        [9.051, -1.236],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [154.609, 74.909], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 7",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 7,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-17.258, -8.439],
                        [0, 0],
                        [2.734, 11.499],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [17.255, 8.434],
                        [0, 0],
                        [-2.734, -11.499],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-33.041, -19.557],
                        [15.786, -35.66],
                        [-1.363, 44.1],
                        [-9.65, 27.835],
                        [-9.65, 5.37],
                        [-26.402, 35.663],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.258999992819, 0.26699999641, 0.368999974868, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [115.693, 163.798], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 8",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 8,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-10.342, 2.357],
                        [-10.554, 1.053],
                        [10.343, -2.357],
                        [10.554, -1.056],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.980000035903, 0.830999995213, 0.451000019148, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [155.683, 71.504], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 9",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 9,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-10.342, 2.355],
                        [-10.554, 1.053],
                        [10.343, -2.355],
                        [10.554, -1.057],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.980000035903, 0.830999995213, 0.451000019148, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [155.232, 68.748], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 10",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 10,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-1.071, -1.04],
                        [1.071, -0.337],
                        [-0.732, 1.04],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.105999995213, 0.141000007181, 0.255000005984, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [171.278, 67.689], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 11",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 11,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-737.5, 631.19],
                        [737.5, 631.19],
                        [737.5, -631.19],
                        [-737.5, -631.19],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-737.5, -631.186],
                        [737.5, -631.186],
                        [737.5, 631.19],
                        [-737.5, 631.19],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 2",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 2,
                  ty: "sh",
                  ix: 3,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-106.237, 117.275],
                        [-101.122, 117.275],
                        [-101.122, 111.559],
                        [-106.237, 111.559],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 3",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 3,
                  ty: "sh",
                  ix: 4,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-106.237, 111.56],
                        [-101.461, 112.697],
                        [-101.122, 114.777],
                        [-105.303, 117.276],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 4",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "mm",
                  mm: 1,
                  nm: "Merge Paths 1",
                  mn: "ADBE Vector Filter - Merge",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.5, 0.5, 0.5, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [271.668, -46.049], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 12",
              np: 6,
              cix: 2,
              bm: 0,
              ix: 12,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-0.421, -2.582],
                        [-1.586, 0.247],
                      ],
                      o: [
                        [-1.581, 0.269],
                        [0.459, 2.822],
                        [0, 0],
                      ],
                      v: [
                        [0.938, -3.09],
                        [-1.462, 0.268],
                        [1.883, 2.693],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.105999995213, 0.141000007181, 0.255000005984, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [142.038, 72.269], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 13",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 13,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-737.5, 631.19],
                        [737.5, 631.19],
                        [737.5, -631.19],
                        [-737.5, -631.19],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-737.5, -631.186],
                        [737.5, -631.186],
                        [737.5, 631.19],
                        [-737.5, 631.19],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 2",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 2,
                  ty: "sh",
                  ix: 3,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-129.107, 121.009],
                        [-126.2, 121.009],
                        [-126.2, 114.973],
                        [-129.107, 114.973],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 3",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 3,
                  ty: "sh",
                  ix: 4,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-128.173, 121.009],
                        [-129.107, 115.293],
                        [-127.131, 114.973],
                        [-126.2, 120.689],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 4",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "mm",
                  mm: 1,
                  nm: "Merge Paths 1",
                  mn: "ADBE Vector Filter - Merge",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.5, 0.5, 0.5, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [271.668, -46.049], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 14",
              np: 6,
              cix: 2,
              bm: 0,
              ix: 14,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [10.345, -4.623],
                        [-11.279, -1.09],
                        [-10.345, 4.623],
                        [11.279, 1.093],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.933000033509, 0.620000023935, 0.20800000359, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [155.086, 70.133], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 15",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 15,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [7.413, -9.022],
                        [0.875, -4.182],
                        [2.696, -1.645],
                        [-11.684, -11.878],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-3.03, 3.688],
                        [-0.646, 3.093],
                        [-7.47, 4.562],
                        [15.593, 15.846],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [22.461, -36.646],
                        [0.73, -27.7],
                        [-4.268, -13.599],
                        [-9.479, -6.151],
                        [-18.7, 20.876],
                        [6.611, 22.408],
                        [30.383, -35.008],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.113999998803, 0.118000000598, 0.187999994615, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [67.093, 82.976], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 16",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 16,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-2.557, -2.842],
                        [-4.601, 1.251],
                        [3.02, 2.842],
                        [4.601, -0.793],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.980000035903, 0.830999995213, 0.451000019148, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [93.9, 45.846], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 17",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 17,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [-1.371, -0.877],
                        [-3.524, -1.042],
                        [3.924, 2.715],
                        [0.57, 2.256],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0.527, 1.54],
                        [1.512, 0.969],
                        [-4.311, 3.68],
                        [-1.911, -1.325],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-2.633, -8.955],
                        [-0.119, -1.656],
                        [2.811, 2.064],
                        [10.215, 5.275],
                        [-4.879, 2.547],
                        [-8.715, -3.011],
                        [-10.215, -8.955],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [118.685, 212.79], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 18",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 18,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-0.665, -3.632],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.421, -0.304],
                        [0, 0],
                        [-1.355, 0],
                        [0, 0],
                        [11.591, 1.722],
                      ],
                      o: [
                        [0, 0],
                        [0.666, 3.636],
                        [0, 0],
                        [0, 0],
                        [0.01, -0.521],
                        [0, 0],
                        [1.094, 0.795],
                        [0, 0],
                        [0, 0],
                        [-11.591, -1.72],
                      ],
                      v: [
                        [-12.986, -7.636],
                        [-16.538, -1.779],
                        [-14.816, 7.636],
                        [-12.292, 7.636],
                        [-12.201, 3.356],
                        [-11.18, 2.847],
                        [-6.285, 6.411],
                        [-2.519, 7.636],
                        [17.203, 7.636],
                        [5.613, -0.4],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.113999998803, 0.118000000598, 0.187999994615, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [123.287, 218.466], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 19",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 19,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [12.251, 0.416],
                        [0.019, -5.499],
                        [0, 0],
                        [0, 0],
                        [-19.436, 5.025],
                      ],
                      o: [
                        [-0.551, 0.505],
                        [-3.041, -0.103],
                        [-0.019, 5.498],
                        [0, 0],
                        [0, 0],
                        [21.01, -5.431],
                      ],
                      v: [
                        [22.223, -1.646],
                        [0.029, 6.019],
                        [-2.665, 11.024],
                        [-6.127, 22.401],
                        [-13.284, 20.353],
                        [-2.787, -16.97],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.113999998803, 0.118000000598, 0.187999994615, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [104.627, 22.651], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 20",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 20,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-4.263, -0.567],
                        [-1.083, 0.69],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.932, -3.253],
                      ],
                      o: [
                        [1.955, 0.261],
                        [7.089, -8.027],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.882, 4.288],
                        [3.248, 2.816],
                      ],
                      v: [
                        [1.819, 19.508],
                        [6.715, 19.057],
                        [11.371, -12.618],
                        [3.076, -19.77],
                        [-9.615, -13.848],
                        [-12.922, -0.85],
                        [-9.661, 14.208],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.941000007181, 0.670999983245, 0.522000002394, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [115.044, 32.611], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 21",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 21,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [9.41, 0.908],
                        [2.246, 16.906],
                        [-9.41, 6.401],
                        [-1.189, -16.906],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.925, 0.588000009574, 0.486000001197, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [103.311, 50.199], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 22",
              np: 2,
              cix: 2,
              bm: 0,
              ix: 22,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 61.0000024845809,
          st: 0,
          bm: 0,
        },
      ],
    },
    {
      id: "comp_3",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Leaf6 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 17,
                  s: [7],
                },
                { t: 59.0000024031193, s: [0] },
              ],
              ix: 10,
            },
            p: { a: 0, k: [951.498, 923.255, 0], ix: 2 },
            a: { a: 0, k: [44.64, 140.231, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0.416, -0.836],
                        [0, 0],
                        [0, 0],
                        [1.778, -0.424],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-1.621, -0.485],
                        [0, 0],
                        [0, 0],
                        [-0.473, -0.746],
                      ],
                      o: [
                        [-0.413, 0.847],
                        [0, 0],
                        [0, 0],
                        [-1.776, 0.462],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.63, 0.45],
                        [0, 0],
                        [0, 0],
                        [0.483, 0.73],
                        [0, 0],
                      ],
                      v: [
                        [169.984, -30.768],
                        [168.732, -28.262],
                        [-70.556, -0.449],
                        [22.577, 91.857],
                        [17.247, 93.182],
                        [-76.521, 0.243],
                        [-169.984, 11.107],
                        [-165.033, 5.803],
                        [16.929, -15.345],
                        [79.224, -93.182],
                        [84.101, -91.772],
                        [23.559, -16.117],
                        [168.529, -32.965],
                        [169.984, -30.773],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [223.578, 132.041], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-63.769, -101.021],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-106.776, 219.335],
                        [0, 0],
                      ],
                      v: [
                        [-69.078, -132.719],
                        [196.656, -59.157],
                        [-196.656, 39.845],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.39199999641, 0.736999990426, 0.583999992819, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [196.906, 160.428], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 61.0000024845809,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "Leaf 5 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 28,
                  s: [-4],
                },
                { t: 59.0000024031193, s: [0] },
              ],
              ix: 10,
            },
            p: { a: 0, k: [1011.549, 854.853, 0], ix: 2 },
            a: { a: 0, k: [1.321, 295.33, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-1.522, 0.741],
                        [0, 0],
                        [0, 0],
                        [-1.149, -0.312],
                        [-0.166, -0.684],
                        [0, 0],
                        [0, 0],
                        [0.149, -0.817],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.52, -1.222],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [1.149, 0.288],
                        [0.173, 0.69],
                        [0, 0],
                        [0, 0],
                        [-0.139, 0.819],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-1.534, 1.281],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.504, -0.758],
                      ],
                      v: [
                        [-1.59, -103.115],
                        [5.521, -8.883],
                        [159.652, -127.324],
                        [163.092, -126.461],
                        [163.567, -124.413],
                        [81.017, -60.977],
                        [167.167, -44.077],
                        [166.719, -41.631],
                        [166.296, -39.47],
                        [76.063, -57.17],
                        [-61.508, 48.545],
                        [88.749, 83.025],
                        [84.162, 86.786],
                        [-66.329, 52.251],
                        [-164.015, 127.319],
                        [-167.167, 127.324],
                        [-165.924, 122.863],
                        [1.07, -5.464],
                        [-6.13, -100.869],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [167.417, 168.006], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-165.51, -41.296],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [43.789, 174.937],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-177.114, 43.308],
                        [143.235, -106.244],
                        [-0.662, 147.185],
                        [-187.024, 147.54],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.626999978458, 0.823999980852, 0.732999973671, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [187.274, 147.79], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 61.0000024845809,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Leaf 4 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 26,
                  s: [8],
                },
                { t: 59.0000024031193, s: [0] },
              ],
              ix: 10,
            },
            p: { a: 0, k: [1029.37, 802.739, 0], ix: 2 },
            a: { a: 0, k: [49.806, 324.228, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-0.573, -0.733],
                        [0, 0],
                        [0, 0],
                        [0.155, -1.729],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.874, 1.464],
                        [0, 0],
                        [0, 0],
                        [-0.95, 0.293],
                      ],
                      o: [
                        [0.581, 0.736],
                        [0, 0],
                        [0, 0],
                        [-0.12, 1.746],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.844, -1.468],
                        [0, 0],
                        [0, 0],
                        [0.938, -0.307],
                        [0, 0],
                      ],
                      v: [
                        [27.094, -157.091],
                        [28.805, -154.886],
                        [-54.684, 82.672],
                        [91.22, 24.588],
                        [90.804, 29.801],
                        [-56.744, 88.54],
                        [-80.837, 157.091],
                        [-84.592, 153.635],
                        [-36.57, 16.983],
                        [-36.57, 16.986],
                        [-91.22, -55.816],
                        [-88.654, -60.217],
                        [-34.696, 11.66],
                        [24.283, -156.162],
                        [27.091, -157.091],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 0.995999983245, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [141.026, 157.342], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-149.626, 46.119],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [166.745, 211.596],
                        [0, 0],
                      ],
                      v: [
                        [-167.307, 71.53],
                        [0.562, -187.512],
                        [-41.234, 187.512],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.128999986836, 0.513999968884, 0.497999991623, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [167.557, 187.762], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 61.0000024845809,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "Leaf 3 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 24,
                  s: [-6],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 59,
                  s: [0],
                },
                { t: 89.0000036250443, s: [0] },
              ],
              ix: 10,
            },
            p: { a: 0, k: [442.829, 675.094, 0], ix: 2 },
            a: { a: 0, k: [285.499, 111.92, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-0.345, -0.709],
                        [0, 0],
                        [0, 0],
                        [-1.496, -0.374],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.372, -0.402],
                        [0, 0],
                        [0, 0],
                        [0.405, -0.622],
                      ],
                      o: [
                        [0.339, 0.717],
                        [0, 0],
                        [0, 0],
                        [1.494, 0.404],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-1.38, 0.366],
                        [0, 0],
                        [0, 0],
                        [-0.413, 0.612],
                        [0, 0],
                      ],
                      v: [
                        [-143.156, -27.002],
                        [-142.124, -24.878],
                        [59.414, 0.653],
                        [-19.923, 77.682],
                        [-15.44, 78.846],
                        [64.44, 1.288],
                        [143.157, 11.262],
                        [139.027, 6.746],
                        [-14.231, -12.668],
                        [-66.081, -78.846],
                        [-70.209, -77.695],
                        [-19.814, -13.377],
                        [-141.915, -28.843],
                        [-143.156, -27.01],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [143.41, 111.886], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [54.65, -84.629],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [88.134, 185.885],
                        [0, 0],
                      ],
                      v: [
                        [36.17, -105.009],
                        [-165.401, -50.628],
                        [165.401, 36.275],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.128999986836, 0.513999968884, 0.497999991623, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [165.651, 135.507], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 61.0000024845809,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 5,
          ty: 4,
          nm: "Leaf 2 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 27,
                  s: [3],
                },
                { t: 59.0000024031193, s: [0] },
              ],
              ix: 10,
            },
            p: { a: 0, k: [402.329, 625.747, 0], ix: 2 },
            a: { a: 0, k: [314.981, 248.967, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [1.273, 0.638],
                        [0, 0],
                        [0, 0],
                        [0.969, -0.253],
                        [0.144, -0.578],
                        [0, 0],
                        [0, 0],
                        [-0.117, -0.69],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-1.274, -1.046],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [-0.97, 0.23],
                        [-0.152, 0.578],
                        [0, 0],
                        [0, 0],
                        [0.109, 0.695],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.284, 1.092],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-1.263, -0.649],
                      ],
                      v: [
                        [2.6, -86.973],
                        [-4.215, -7.571],
                        [-133.159, -108.784],
                        [-136.067, -108.089],
                        [-136.485, -106.365],
                        [-67.426, -52.158],
                        [-140.219, -38.655],
                        [-139.863, -36.586],
                        [-139.524, -34.762],
                        [-63.28, -48.903],
                        [51.805, 41.436],
                        [-75.197, 69.207],
                        [-71.36, 72.42],
                        [55.84, 44.602],
                        [137.563, 108.752],
                        [140.219, 108.784],
                        [139.208, 105.01],
                        [-0.496, -4.65],
                        [6.407, -85.039],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [174.762, 140.183], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [122.381, -31.844],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-38.445, 147.136],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [125.994, 7.107],
                        [-118.92, -92.514],
                        [0.219, 122.44],
                        [157.365, 124.359],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.626999978458, 0.823999980852, 0.732999973671, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [157.615, 124.609], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 61.0000024845809,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 6,
          ty: 4,
          nm: "Leaf 1 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 20,
                  s: [5],
                },
                { t: 59.0000024031193, s: [0] },
              ],
              ix: 10,
            },
            p: { a: 0, k: [388.784, 568.253, 0], ix: 2 },
            a: { a: 0, k: [241.583, 261.089, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0.798, 0.258],
                        [0.488, -0.616],
                        [0, 0],
                        [0, 0],
                        [-0.12, -1.458],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.725, 1.241],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [-0.497, 0.616],
                        [0, 0],
                        [0, 0],
                        [0.084, 1.474],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.7, -1.246],
                        [0, 0],
                        [0, 0],
                        [-0.79, -0.266],
                      ],
                      v: [
                        [-21.616, -132.936],
                        [-23.079, -131.09],
                        [45.26, 69.954],
                        [-77.27, 19.709],
                        [-76.963, 24.107],
                        [46.947, 74.923],
                        [66.667, 132.937],
                        [69.863, 130.056],
                        [30.554, 14.406],
                        [77.27, -46.508],
                        [75.144, -50.241],
                        [29.02, 9.901],
                        [-19.257, -132.13],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [1, 1, 0.995999983245, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [164.313, 133.187], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [125.767, 40.191],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-142.447, 176.982],
                        [0, 0],
                      ],
                      v: [
                        [140.875, 61.594],
                        [1.572, -158.302],
                        [33.557, 158.302],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.128999986836, 0.513999968884, 0.497999991623, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [141.125, 158.552], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 2",
              np: 4,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 61.0000024845809,
          st: 0,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: "Boy on Laptop",
      refId: "comp_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [1103.594, 192.006, 0], ix: 2 },
        a: { a: 0, k: [45.5, 88, 0], ix: 1 },
        s: { a: 0, k: [202.298, 202.298, 100], ix: 6 },
      },
      ao: 0,
      w: 91,
      h: 176,
      ip: 0,
      op: 90.0000036657751,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 0,
      nm: "Guy",
      refId: "comp_1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [366, 706.359, 0], ix: 2 },
        a: { a: 0, k: [47.5, 100, 0], ix: 1 },
        s: { a: 0, k: [204, 204, 100], ix: 6 },
      },
      ao: 0,
      w: 95,
      h: 200,
      ip: 0,
      op: 90.0000036657751,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 2,
      nm: "Hand - top",
      refId: "image_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 3,
              s: [0],
            },
            {
              i: { x: [0.095], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 13,
              s: [-9],
            },
            {
              i: { x: [0.095], y: [1] },
              o: { x: [0.768], y: [0] },
              t: 21,
              s: [-14],
            },
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.768], y: [0] },
              t: 28,
              s: [-14],
            },
            { t: 47.0000019143492, s: [4] },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 3,
              s: [1198.653, 994.673, 0],
              to: [-4, 0, 0],
              ti: [0.333, -4.167, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 13,
              s: [1174.653, 994.673, 0],
              to: [-0.333, 4.167, 0],
              ti: [-3.667, -4.167, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.167, y: 0.167 },
              t: 24,
              s: [1196.653, 1019.673, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.167, y: 0 },
              t: 28,
              s: [1196.653, 1019.673, 0],
              to: [0.333, -4.167, 0],
              ti: [-0.333, 4.167, 0],
            },
            { t: 47.0000019143492, s: [1198.653, 994.673, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [92.421, 173, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 61.0000024845809,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 2,
      nm: "Bottom",
      refId: "image_1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 3,
              s: [0],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 13,
              s: [-10],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 24,
              s: [-2],
            },
            {
              i: { x: [0.835], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 28,
              s: [-2],
            },
            { t: 47.0000019143492, s: [0] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [1202.998, 1103.827, 0], ix: 2 },
        a: {
          a: 1,
          k: [
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 10,
              s: [30, 110, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 28.0000011404634, s: [30, 110, 0] },
          ],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 13,
              s: [100, 100, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 24,
              s: [100, 80, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 28,
              s: [100, 80, 100],
            },
            { t: 47.0000019143492, s: [100, 100, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      ip: 0,
      op: 61.0000024845809,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 2,
      nm: "Left leg",
      refId: "image_2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [1191.024, 1157.006, 0], ix: 2 },
        a: { a: 0, k: [25.409, 89.062, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 61.0000024845809,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 2,
      nm: "Head",
      parent: 7,
      refId: "image_3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [18.335, 14.33, 0], ix: 2 },
        a: { a: 0, k: [33.977, 58.521, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 61.0000024845809,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 2,
      nm: "Neck",
      parent: 3,
      refId: "image_4",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [92.209, 92.296, 0], ix: 2 },
        a: { a: 0, k: [9.288, 9.244, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 61.0000024845809,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 2,
      nm: "Right leg",
      refId: "image_5",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 3,
              s: [0],
            },
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 10,
              s: [-8],
            },
            { t: 27.0000010997325, s: [-6] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [1216.422, 1086.95, 0], ix: 2 },
        a: { a: 0, k: [26.5, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 61.0000024845809,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 2,
      nm: "Pencil",
      parent: 3,
      refId: "image_6",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 7, ix: 10 },
        p: { a: 0, k: [23.906, 13.135, 0], ix: 2 },
        a: { a: 0, k: [153.203, 275.831, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 61.0000024845809,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: "Tick 2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [870.15, 565.873, 0], ix: 2 },
        a: { a: 0, k: [104.306, -275.553, 0], ix: 1 },
        s: { a: 0, k: [280, 280, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [-6.792, 34.263],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [6.815, -34.376],
                  ],
                  v: [
                    [103.991, -276.144],
                    [120.614, -254.753],
                    [139.74, -295.83],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [0.290196078431, 0.800000059838, 0.419607873056, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 12, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100.303, 99.786], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Shape 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "tm",
          s: { a: 0, k: 0, ix: 1 },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                t: 13,
                s: [0],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.862], y: [0] },
                t: 26,
                s: [36.935],
              },
              { t: 44.0000017921567, s: [100] },
            ],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false,
        },
      ],
      ip: 0,
      op: 101.000004113814,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 0,
      nm: "Girl 2",
      refId: "comp_2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [552.132, 802.403, 0], ix: 2 },
        a: { a: 0, k: [86.3, 125.164, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      w: 173,
      h: 251,
      ip: 0,
      op: 61.0000024845809,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 12,
      ty: 4,
      nm: "Ladder Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [459.062, 1058.659, 0], ix: 2 },
        a: { a: 0, k: [315.063, 159.26, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-245.89, 7.753],
                    [245.89, 7.753],
                    [245.89, -7.753],
                    [-245.89, -7.753],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [320.426, 8.003], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [47.181, -4.672],
                    [51.253, 4.728],
                    [-49.53, 4.668],
                    [-51.253, -4.729],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [561.037, 264.264], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [47.181, -4.67],
                    [51.254, 4.73],
                    [-49.533, 4.668],
                    [-51.254, -4.73],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [543.344, 201.427], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [47.18, -4.671],
                    [51.253, 4.732],
                    [-49.531, 4.67],
                    [-51.253, -4.731],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [524.447, 137.156], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 4",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [51.254, -4.668],
                    [51.254, 4.729],
                    [-49.533, 4.668],
                    [-51.254, -4.729],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [502.553, 72.885], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 5",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-51.777, -155.551],
                    [41.062, 155.551],
                    [51.777, 155.551],
                    [-41.063, -155.551],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [480.838, 162.718], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 6",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-51.776, -155.551],
                    [41.061, 155.551],
                    [51.775, 155.551],
                    [-41.065, -155.551],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [578.101, 162.718], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 7",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-47.18, -4.672],
                    [-51.253, 4.728],
                    [49.531, 4.668],
                    [51.253, -4.729],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [69.089, 264.264], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 8",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-47.181, -4.67],
                    [-51.255, 4.73],
                    [49.53, 4.668],
                    [51.255, -4.73],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [86.786, 201.427], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 9",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-47.181, -4.671],
                    [-51.254, 4.732],
                    [49.53, 4.67],
                    [51.254, -4.731],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [105.681, 137.156], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 10",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-51.252, -4.668],
                    [-51.252, 4.729],
                    [49.532, 4.668],
                    [51.252, -4.729],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [127.575, 72.885], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 11",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [41.065, -155.551],
                    [-51.777, 155.551],
                    [-41.062, 155.551],
                    [51.777, -155.551],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [149.289, 162.718], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 12",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [41.064, -155.551],
                    [-51.775, 155.551],
                    [-41.064, 155.551],
                    [51.775, -155.551],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [52.025, 162.718], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 13",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 61.0000024845809,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 13,
      ty: 4,
      nm: "Note Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [724.257, 652.001, 0], ix: 2 },
        a: { a: 0, k: [395.083, 527.759, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-1.708, 7.898],
                    [1.629, 7.861],
                    [1.536, 23.829],
                    [-1.806, 23.85],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-1.516, -23.788],
                    [1.806, -23.85],
                    [1.719, -8.032],
                    [-1.61, -7.983],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 1,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.721568644047, 0.776470661163, 0.811764776707, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 2",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.721568644047, 0.776470661163, 0.811764776707, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [655.219, 492.076], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 7,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-4.216, 4.888],
                    [4.163, 4.888],
                    [4.215, -4.888],
                    [0.866, -4.881],
                    [0.829, 0.979],
                    [-4.19, 0.984],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.721568644047, 0.776470661163, 0.811764776707, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 2",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 0.995999983245, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [652.451, 536.838], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 5,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.777, 4.799],
                    [4.09, 4.723],
                    [4.143, -4.799],
                    [-4.116, -4.59],
                    [-4.143, -0.792],
                    [0.81, -0.914],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.721568644047, 0.776470661163, 0.811764776707, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 2",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 0.995999983245, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [653.024, 447.759], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 3",
          np: 5,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [100.119, 39.992],
                    [83.866, -29.133],
                    [-84.126, -29.133],
                    [-100.243, 27.543],
                    [-110.692, 24.573],
                    [-92.331, -39.992],
                    [92.468, -39.992],
                    [110.692, 37.506],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [405.588, 40.242], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 4",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-116.258, 50.424],
                    [116.258, 50.424],
                    [116.258, -50.424],
                    [-116.258, -50.424],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.791999966491, 0.834999952129, 0.866999966491, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [405.555, 81.425], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 5",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -8.841],
                    [-8.838, 0],
                    [0, 8.841],
                    [8.841, 0],
                  ],
                  o: [
                    [0, 8.841],
                    [8.841, 0],
                    [0, -8.841],
                    [-8.838, 0],
                  ],
                  v: [
                    [-16.008, 0],
                    [-0.002, 16.006],
                    [16.007, 0],
                    [-0.002, -16.006],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.075, 0.216000007181, 0.301999978458, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [675.084, 144.048], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 6",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -8.841],
                    [-8.841, 0],
                    [0, 8.841],
                    [8.841, 0],
                  ],
                  o: [
                    [0, 8.841],
                    [8.841, 0],
                    [0, -8.841],
                    [-8.841, 0],
                  ],
                  v: [
                    [-16.007, 0],
                    [0.001, 16.006],
                    [16.007, 0],
                    [0.001, -16.006],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 0.995999983245, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [720.413, 144.048], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 7",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-1.741, 7.662],
                    [1.398, 7.63],
                    [1.042, 23.117],
                    [-2.102, 23.139],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-1.024, -23.081],
                    [2.102, -23.139],
                    [1.751, -7.793],
                    [-1.383, -7.743],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 1,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [538.898, 700], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 8",
          np: 6,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-4.005, 4.718],
                    [-0.886, 4.648],
                    [-0.764, -0.902],
                    [3.921, -1.016],
                    [4.005, -4.718],
                    [-3.791, -4.516],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [542.235, 656.935], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 9",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-39.885, -0.838],
                    [-28.683, -1.125],
                    [-28.753, 2.597],
                    [-39.962, 2.871],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-17.411, -1.41],
                    [-6.073, -1.698],
                    [-6.133, 2.043],
                    [-17.475, 2.32],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 2,
              ty: "sh",
              ix: 3,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [5.331, -1.989],
                    [16.805, -2.279],
                    [16.76, 1.483],
                    [5.282, 1.764],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 3",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 3,
              ty: "sh",
              ix: 4,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [28.347, -2.575],
                    [39.961, -2.871],
                    [39.928, 0.916],
                    [28.309, 1.201],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 4",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 1,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [597.263, 652.773], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 10",
          np: 8,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0.777, 4.8],
                    [4.09, 4.725],
                    [4.143, -4.8],
                    [-4.116, -4.588],
                    [-4.143, -0.79],
                    [0.81, -0.912],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [653.024, 654.194], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 11",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-1.708, 7.896],
                    [1.629, 7.86],
                    [1.536, 23.829],
                    [-1.806, 23.85],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-1.516, -23.789],
                    [1.806, -23.851],
                    [1.719, -8.031],
                    [-1.61, -7.983],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 1,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [655.219, 698.512], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 12",
          np: 6,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-4.216, 4.889],
                    [4.163, 4.889],
                    [4.215, -4.889],
                    [0.866, -4.881],
                    [0.829, 0.979],
                    [-4.19, 0.984],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [652.451, 743.274], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 13",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-40.423, -1.865],
                    [-29.073, -1.876],
                    [-29.144, 1.948],
                    [-40.505, 1.948],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-17.654, -1.886],
                    [-6.159, -1.901],
                    [-6.222, 1.948],
                    [-17.716, 1.948],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 2,
              ty: "sh",
              ix: 3,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [5.401, -1.911],
                    [17.031, -1.923],
                    [16.984, 1.948],
                    [5.348, 1.948],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 3",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 3,
              ty: "sh",
              ix: 4,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [28.731, -1.933],
                    [40.505, -1.948],
                    [40.474, 1.948],
                    [28.693, 1.948],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 4",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 1,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [595.909, 746.216], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 14",
          np: 8,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-3.991, 4.742],
                    [3.907, 4.742],
                    [3.991, 0.94],
                    [-0.75, 0.946],
                    [-0.619, -4.742],
                    [-3.771, -4.735],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [540.204, 743.421], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 15",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 15,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [86.389, -79.01],
                    [85.979, 79.01],
                    [-86.389, 79.01],
                    [-80.088, -79.01],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [596.286, 700.25], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 16",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 16,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-1.741, 7.662],
                    [1.398, 7.629],
                    [1.042, 23.117],
                    [-2.102, 23.139],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-1.024, -23.079],
                    [2.102, -23.139],
                    [1.751, -7.79],
                    [-1.383, -7.743],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 1,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [538.898, 493.564], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 17",
          np: 6,
          cix: 2,
          bm: 0,
          ix: 17,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-4.005, 4.716],
                    [-0.886, 4.643],
                    [-0.764, -0.904],
                    [3.921, -1.017],
                    [4.005, -4.716],
                    [-3.791, -4.521],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [542.235, 450.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 18",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 18,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-39.885, -0.839],
                    [-28.683, -1.124],
                    [-28.753, 2.596],
                    [-39.962, 2.87],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-17.411, -1.412],
                    [-6.073, -1.7],
                    [-6.133, 2.042],
                    [-17.475, 2.322],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 2,
              ty: "sh",
              ix: 3,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [5.331, -1.99],
                    [16.805, -2.283],
                    [16.76, 1.482],
                    [5.282, 1.765],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 3",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 3,
              ty: "sh",
              ix: 4,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [28.347, -2.577],
                    [39.961, -2.87],
                    [39.928, 0.915],
                    [28.309, 1.2],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 4",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 1,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [597.263, 446.338], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 19",
          np: 8,
          cix: 2,
          bm: 0,
          ix: 19,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-40.423, -1.863],
                    [-29.073, -1.877],
                    [-29.144, 1.947],
                    [-40.505, 1.947],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-17.654, -1.887],
                    [-6.159, -1.898],
                    [-6.222, 1.947],
                    [-17.716, 1.947],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 2,
              ty: "sh",
              ix: 3,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [5.401, -1.912],
                    [17.031, -1.923],
                    [16.984, 1.947],
                    [5.348, 1.947],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 3",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 3,
              ty: "sh",
              ix: 4,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [28.731, -1.936],
                    [40.505, -1.947],
                    [40.474, 1.947],
                    [28.693, 1.947],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 4",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 1,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [595.909, 539.78], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 20",
          np: 8,
          cix: 2,
          bm: 0,
          ix: 20,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-3.991, 4.74],
                    [3.907, 4.74],
                    [3.991, 0.942],
                    [-0.749, 0.947],
                    [-0.619, -4.74],
                    [-3.771, -4.734],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [540.204, 536.986], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 21",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 21,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [86.389, -79.01],
                    [85.979, 79.01],
                    [-86.389, 79.01],
                    [-80.088, -79.01],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [596.286, 493.813], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 22",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 22,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [1.865, -6.071],
                    [-6.074, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-6.072, 0],
                    [-1.865, 6.074],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [110.02, -11.043],
                    [-93.721, -11.043],
                    [-108.154, 0],
                    [-100.5, 11.043],
                    [89.362, 11.043],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [525.817, 903.32], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 23",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 23,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-1.866, 6.074],
                    [-6.073, 0],
                    [0, 0],
                    [1.865, -6.071],
                    [6.074, 0],
                  ],
                  o: [
                    [-6.074, 0],
                    [1.865, -6.071],
                    [0, 0],
                    [6.074, 0],
                    [-1.864, 6.074],
                    [0, 0],
                  ],
                  v: [
                    [-144.47, 11.043],
                    [-152.125, 0],
                    [-137.691, -11.043],
                    [144.47, -11.043],
                    [152.125, 0],
                    [137.691, 11.043],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [569.788, 903.319], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 24",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 24,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [1.415, -6.074],
                    [-4.611, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-4.61, 0],
                    [-1.417, 6.073],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [67.709, -11.044],
                    [-55.335, -11.044],
                    [-66.291, -0.001],
                    [-60.483, 11.044],
                    [51.215, 11.044],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [483.962, 944.247], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 25",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 25,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [6.073, 0],
                    [0, 0],
                    [-1.866, 6.073],
                    [-6.074, 0],
                    [0, 0],
                    [1.868, -6.074],
                  ],
                  o: [
                    [0, 0],
                    [-6.074, 0],
                    [1.863, -6.074],
                    [0, 0],
                    [6.074, 0],
                    [-1.863, 6.073],
                  ],
                  v: [
                    [137.689, 11.044],
                    [-144.47, 11.044],
                    [-152.124, -0.001],
                    [-137.69, -11.044],
                    [144.471, -11.044],
                    [152.122, -0.001],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [569.918, 944.247], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 26",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 26,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [1.863, -6.074],
                    [-6.074, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-6.075, 0],
                    [-1.865, 6.076],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [89.202, -11.044],
                    [-72.902, -11.044],
                    [-87.337, -0.001],
                    [-79.683, 11.044],
                    [67.473, 11.044],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [505.13, 861.183], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 27",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 27,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-1.866, 6.076],
                    [-6.074, 0],
                    [0, 0],
                    [1.868, -6.074],
                    [6.073, 0],
                  ],
                  o: [
                    [-6.074, 0],
                    [1.863, -6.074],
                    [0, 0],
                    [6.075, 0],
                    [-1.863, 6.076],
                    [0, 0],
                  ],
                  v: [
                    [-144.47, 11.044],
                    [-152.125, -0.001],
                    [-137.69, -11.044],
                    [144.47, -11.044],
                    [152.122, -0.001],
                    [137.688, 11.044],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [569.918, 861.183], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 28",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 28,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-109.18, -9.579],
                    [-110.305, 9.579],
                    [105.893, 9.579],
                    [110.305, -7.345],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [217.89, 930.643], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 29",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 29,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-131.093, -7.305],
                    [-130.96, 7.306],
                    [128.442, 7.306],
                    [131.093, -5.6],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [239.339, 886.842], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 30",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 30,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-109.18, -9.579],
                    [-110.305, 9.579],
                    [105.893, 9.579],
                    [110.305, -7.342],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [217.89, 842.777], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 31",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 31,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-109.182, -9.581],
                    [-110.303, 9.581],
                    [105.891, 9.581],
                    [110.303, -7.343],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [223.323, 714.208], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 32",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 32,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-166.348, -7.305],
                    [-166.18, 7.306],
                    [162.986, 7.306],
                    [166.348, -5.6],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [280.024, 670.405], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 33",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 33,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-109.182, -9.579],
                    [-110.303, 9.579],
                    [105.891, 9.579],
                    [110.303, -7.342],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [223.323, 626.341], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 34",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 34,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-160.929, -7.305],
                    [-160.766, 7.305],
                    [157.673, 7.305],
                    [160.929, -5.6],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [274.584, 558.158], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 35",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 35,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-105.624, -9.581],
                    [-106.71, 9.581],
                    [102.441, 9.581],
                    [106.71, -7.344],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [219.729, 514.095], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 36",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 36,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-160.929, -7.306],
                    [-160.766, 7.306],
                    [157.673, 7.306],
                    [160.929, -5.6],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [274.584, 470.293], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 37",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 37,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-105.624, -9.58],
                    [-106.71, 9.58],
                    [102.441, 9.58],
                    [106.71, -7.341],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [219.729, 426.229], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 38",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 38,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-285.223, -6.589],
                    [-284.935, 6.589],
                    [279.456, 6.589],
                    [285.222, -5.049],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [396.656, 344.971], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 39",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 39,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-187.204, -8.639],
                    [-189.129, 8.639],
                    [181.565, 8.639],
                    [189.13, -6.621],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.961000031116, 0.972999961703, 0.976000019148, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [299.433, 305.234], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 40",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 40,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-285.223, -6.589],
                    [-284.935, 6.589],
                    [279.456, 6.589],
                    [285.222, -5.048],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [396.656, 265.733], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 41",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 41,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-187.204, -8.639],
                    [-189.129, 8.639],
                    [181.565, 8.639],
                    [189.13, -6.621],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.722000002394, 0.776000019148, 0.811999990426, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [299.433, 225.995], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 42",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 42,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-358.107, -26.783],
                    [-359.564, 28.301],
                    [359.563, 28.301],
                    [359.074, -28.301],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.885999971278, 0.093999997307, 0.219999994016, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [397.769, 145.056], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 43",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 43,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-394.833, 485.734],
                    [394.833, 485.734],
                    [394.833, -485.734],
                    [-394.833, -485.734],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [395.083, 569.534], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 44",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 44,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 61.0000024845809,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 14,
      ty: 2,
      nm: "Layer 2/Shadow 4 9.ai",
      cl: "ai",
      refId: "image_7",
      sr: 1,
      ks: {
        o: { a: 0, k: 80, ix: 11 },
        r: { a: 0, k: 90, ix: 10 },
        p: { a: 0, k: [728.5, 697.5, 0], ix: 2 },
        a: { a: 0, k: [292.5, 201, 0], ix: 1 },
        s: { a: 0, k: [187.382, 237.179, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 60.0000024438501,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 15,
      ty: 0,
      nm: "Leaf14",
      refId: "comp_3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [737.5, 631.5, 0], ix: 2 },
        a: { a: 0, k: [737.5, 631.5, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      w: 1475,
      h: 1263,
      ip: 0,
      op: 60.0000024438501,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};

export default awaitApproval;
